import { useEffect, useRef, useState } from "react";
import Controls from "../../../components/visualizations/Controls.jsx";
import VisualizationGrid from "../../../components/visualizations/VisualizationGrid.jsx";
import { getMyVisualizations } from "../../../services/visualizations.service.js";
import LoadTrigger from "../../../components/common/LoadTrigger.jsx";
import PageHeader from "../../../components/common/PageHeader.jsx";
import { useNavigate } from "react-router-dom";
import StudioVisualizationCard from "../../../components/studio/StudioVisualizationCard.jsx";

const MyVisualizations = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("publishedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [records, setRecords] = useState([]);
  const pageRef = useRef(1);
  const reqIdRef = useRef(1);
  const syncIsLoadingRef = useRef(false);
  const sortOptions = {
    Title: "title",
    CreatedAt: "createdAt",
    PublishedAt: "publishedAt",
    Views: "views",
    Likes: "likesCount",
  };

  const onLoadMore = async (reset = false) => {
    if (!reset && (syncIsLoadingRef.current || !hasMore)) return;

    setIsLoading(true);
    syncIsLoadingRef.current = true;
    try {
      const query = {
        page: reset ? 1 : pageRef.current,
        sortBy,
        sortOrder,
        ...(search ? { search } : {}),
      };

      if (reset) {
        pageRef.current = 2;
        ++reqIdRef.current;
        setHasMore(true);
      } else {
        pageRef.current++;
      }
      const reqId = reqIdRef.current;

      const visualizationsData = await getMyVisualizations(query);
      if (reqId !== reqIdRef.current) {
        return;
      }
      setHasMore(visualizationsData.page < visualizationsData.totalPages);
      setRecords((prev) =>
        reset
          ? visualizationsData.records
          : [...prev, ...visualizationsData.records],
      );
    } catch (error) {
      --pageRef.current;
    } finally {
      setIsLoading(false);
      syncIsLoadingRef.current = false;
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(async () => await onLoadMore(true), 500);
    return () => clearTimeout(timeoutId);
  }, [search, sortBy, sortOrder]);

  return (
    <>
      <PageHeader
        title={"Visualizations"}
        description={
          "Manage your visualizations - published and drafts - all in one place."
        }
        action={
          <button
            className="primary-btn"
            onClick={() => navigate("/studio/visualizations/new")}
          >
            + New Visualization
          </button>
        }
      />
      <Controls
        setDebouncedSearch={setSearch}
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        sortOptions={sortOptions}
      />
      <VisualizationGrid
        records={records}
        isLoading={isLoading}
        isStudio={true}
        Card={StudioVisualizationCard}
        onDelete={(id) => setRecords((prev) => prev.filter((r) => r.publicationId !== id))}
      />
      <LoadTrigger
        hasMore={hasMore}
        isLoading={isLoading}
        onLoadMore={onLoadMore}
      />
    </>
  );
};

export default MyVisualizations;
